// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Cwih","row":"Node_row__TyAui","label":"Node_label__1F9QA","footer":"Node_footer__2ykcR"};